export const pick = (obj, keys) => {
    if (!obj)
        return {};
    const newObj = {};
    for (const k of keys) {
        const v = obj[k];
        // Don't pick undefined
        if (v === undefined)
            continue;
        newObj[k] = v;
    }
    return newObj;
};
//# sourceMappingURL=pick.js.map